import { render, staticRenderFns } from "./phdp-index-1.vue?vue&type=template&id=9cfe4d6c&scoped=true"
import script from "./phdp-index-1.vue?vue&type=script&lang=js"
export * from "./phdp-index-1.vue?vue&type=script&lang=js"
import style0 from "./phdp-index-1.vue?vue&type=style&index=0&id=9cfe4d6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfe4d6c",
  null
  
)

export default component.exports